import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import { CompanyPartHeader } from "../../../components/PartHeader";
import { SYSTEM_PATH_COMPANY } from "../../../App";

const infoTableCellSx = {
  fontSize: 18,
};

function ProductInfoTable(props) {
  const { product, onClickDeleteProduct } = props;
  const navigate = useNavigate();

  return (
    <>
      <Typography>商品コード : {product.productId || ""}</Typography>
      <Grid container spacing={2}>
        <Grid item xs>
          <Typography fontWeight="bold" fontSize={30}>
            {product.productName}
          </Typography>
        </Grid>
        <Grid item xs="auto">
          <Button
            variant="outlined"
            onClick={() => navigate(SYSTEM_PATH_COMPANY + "/product_master")}
          >
            商品マスタに戻る
          </Button>
        </Grid>
      </Grid>

      <CompanyPartHeader>
        <Grid container spacing={1}>
          <Grid item xs>
            <Typography fontWeight="bold" fontSize={20}>
              商品基本情報
            </Typography>
          </Grid>
          <Grid item xs="auto">
            <Button
              variant="outlined"
              onClick={() =>
                navigate(`/company/product_edit`, {
                  state: {
                    productId: product.productId,
                  },
                })
              }
            >
              編集
            </Button>
          </Grid>
          <Grid item xs="auto">
            <Button
              variant="outlined"
              color="error"
              onClick={() => onClickDeleteProduct(product)}
            >
              削除
            </Button>
          </Grid>
        </Grid>
      </CompanyPartHeader>
      <TableContainer component={Box}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell width={180} sx={infoTableCellSx}>
                商品コード
              </TableCell>
              <TableCell sx={infoTableCellSx}>{product.productId}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell width={180} sx={infoTableCellSx}>
                商品名
              </TableCell>
              <TableCell sx={infoTableCellSx}>{product.productName}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell width={180} sx={infoTableCellSx}>
                商品名カナ
              </TableCell>
              <TableCell sx={infoTableCellSx}>{product.productKana}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell width={180} sx={infoTableCellSx}>
                部門名
              </TableCell>
              <TableCell sx={infoTableCellSx}>
                {product.productClassLName}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell width={180} sx={infoTableCellSx}>
                中分類名
              </TableCell>
              <TableCell sx={infoTableCellSx}>
                {product.productClassMName}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell width={180} sx={infoTableCellSx}>
                小分類名
              </TableCell>
              <TableCell sx={infoTableCellSx}>
                {product.productClassSName}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={infoTableCellSx}>税種</TableCell>
              <TableCell sx={infoTableCellSx}>{`${product.taxName} ${
                product.taxRate * 100
              }%`}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

export default ProductInfoTable;
